import { B2Container, B2Row } from "@hdb/biome-2";
import "./footer.scss";
import link from "src/assets/images/openLinkWhite.png";
import facebook from "src/assets/images/facebook.png";
import whatsapp from "src/assets/images/whatsapp.png";
import telegram from "src/assets/images/telegram.png";
import youtube from "src/assets/images/youtube.png";
import linkedin from "src/assets/images/linkedin.png";
import x from "src/assets/images/x.png";
import instagram from "src/assets/images/instagram.png";

const socialLinks = [
  {
    key: "facebook",
    href: "https://www.facebook.com/SingaporeHDB",
    img: facebook,
    label: "Facebook",
  },
  {
    key: "instagram",
    href: "https://www.instagram.com/singaporehdb/",
    img: instagram,
    label: "Instagram",
  },
  { key: "x", href: "https://x.com/SingaporeHDB", img: x, label: "X" },
  {
    key: "linkedin",
    href: "https://www.linkedin.com/company/singaporehdb",
    img: linkedin,
    label: "LinkedIn",
  },
  {
    key: "youtube",
    href: "https://www.youtube.com/user/singaporeHDB",
    img: youtube,
    label: "YouTube",
  },
  {
    key: "telegram",
    href: "https://t.me/SingaporeHDB",
    img: telegram,
    label: "Telegram",
  },
  {
    key: "whatsapp",
    href: "https://www.whatsapp.com/channel/0029Va3eJi95fM5eWbq2Mi1j",
    img: whatsapp,
    label: "WhatsApp",
  },
];

const FooterComponent = () => {
  const currentEnvironment = process.env.REACT_APP_CURRENT_ENVIRONMENT;

  return (
    <div className="no-page-break">
      <footer className="sg-footer">
        <B2Container className="sg-footer-container">
          <div className="sg-footer-content">
            {currentEnvironment == "sit" ? null : (
              <>
                {/* Main Content Section */}
                <div className="sg-footer-main">
                  <div className="sg-footer-brand">
                    <h3>Housing & Development Board</h3>
                  </div>

                  <div className="sg-footer-links-section">
                    <div className="sg-footer-contact-links">
                      <a
                        href="https://www.hdb.gov.sg/cs/infoweb/contact-us"
                        className="sg-footer-link"
                      >
                        Contact Us
                      </a>
                      <a
                        href="https://services2.hdb.gov.sg/webapp/BF12AWFeedback/BF12SFrontController?service=ServiceFeedback&operation=createFeedback"
                        className="sg-footer-link"
                      >
                        Write to Us
                      </a>
                    </div>
                    <div className="sg-footer-divider-line"></div>

                    <div className="sg-footer-social-icons">
                      {socialLinks.map(({ key, href, img, label }) => (
                        <a
                          key={key}
                          href={href}
                          target="_blank"
                          rel="noopener noreferrer"
                          className={`sg-social-icon ${key}`}
                          aria-label={label}
                        >
                          <span
                            className="sg-social-mask"
                            style={{
                              WebkitMaskImage: `url(${img})`,
                              maskImage: `url(${img})`,
                            }}
                            aria-hidden="true"
                          />
                        </a>
                      ))}
                    </div>
                  </div>
                </div>

                {/* Footer Links */}
                <div className="sg-footer-links">
                  <a
                    href="https://www.tech.gov.sg/report-vulnerability/"
                    className="sg-footer-nav-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Report Vulnerabilities{" "}
                    <img className="sg-link-icon" src={link} alt="link Icon" />
                  </a>
                  <span className="sg-footer-divider">|</span>
                  <a
                    href="https://www.hdb.gov.sg/cs/infoweb/privacy-statement"
                    className="sg-footer-nav-link"
                  >
                    Privacy Statement
                  </a>
                  <span className="sg-footer-divider">|</span>
                  <a
                    href="https://www.hdb.gov.sg/cs/infoweb/terms-of-use"
                    className="sg-footer-nav-link"
                  >
                    Terms of Use
                  </a>
                </div>
              </>
            )}

            {/* Copyright */}
            <div className="sg-footer-copyright">
              <span>
                © 2026{" "}
                {currentEnvironment == "sit" ? "" : "Government of Singapore"}
              </span>
            </div>
          </div>
        </B2Container>
      </footer>
    </div>
  );
};

export default FooterComponent;
